export const FloatingComponent = ({children, className = ''}) => {

    return (
        <section className={` z-50 w-full h-svh sm:p-10 fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 overflow-y-auto   bg-gray-800 bg-opacity-50 flex justify-center ${className}`}>
            {children}
        </section>
    );

}